import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logoIcon from "../../assets/pnrbet-icon.png";
import { Icon } from "@/components/Icon";
import { ENTITY, ADDRESS, NPN } from "../../legal/common";
import { hubGroups } from "../../legal/registry";

function StatusBadge({ policy }) {
  if (!policy.effectiveDate) return null;
  return (
    <span className="shrink-0 rounded-full border border-pnr-green/40 bg-pnr-green/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-pnr-green">
      In effect · {policy.effectiveDate}
    </span>
  );
}

export default function LegalHub() {
  useEffect(() => { document.title = "Legal & Policies · PRYMEBET"; }, []);
  const groups = hubGroups();
  return (
    <div className="min-h-[100dvh] bg-surface-1 text-white">
      <header className="border-b border-surface-border">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4 pt-[max(1rem,env(safe-area-inset-top))] sm:px-6">
          <Link to="/" className="flex items-center gap-2 focus-ring" data-testid="legal-home-link">
            <img src={logoIcon} alt="" className="h-10 w-10 rounded-md" />
            <span className="font-display text-lg font-extrabold tracking-tighter">PRYMEBET</span>
          </Link>
          <Link to="/" className="text-sm font-medium text-meta underline underline-offset-2 transition-colors hover:text-white focus-ring">Back to home</Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 pb-[max(3rem,env(safe-area-inset-bottom))] sm:px-6 sm:py-12">
        <p className="mb-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-pnr-green">Legal</p>
        <h1 className="font-display text-3xl font-black tracking-tight sm:text-5xl sm:tracking-tighter" data-testid="legal-hub-title">Legal &amp; Policies</h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-meta">
          The agreements, rules, and notices that govern your use of PRYMEBET.
        </p>

        <div className="my-8 flex gap-3 rounded-2xl border border-surface-border bg-surface-3 p-4" data-testid="legal-hub-npn">
          <Icon name="shield-alert" size={20} className="mt-0.5 shrink-0 text-meta" />
          <p className="text-xs font-semibold leading-relaxed text-pnr-green">{NPN}</p>
        </div>

        <div className="space-y-10">
          {groups.map(([category, items]) => (
            <section key={category} data-testid={`legal-group-${category}`}>
              <h2 className="mb-3 font-display text-sm font-bold uppercase tracking-[0.15em] text-meta">{category}</h2>
              <ul className="divide-y divide-surface-border overflow-hidden rounded-2xl border border-surface-border bg-surface-3">
                {items.map((p) => (
                  <li key={p.slug}>
                    <Link
                      to={p.path}
                      data-testid={`legal-link-${p.slug}`}
                      className="flex items-start justify-between gap-4 px-4 py-4 transition-colors hover:bg-surface-4 focus-ring"
                    >
                      <div className="min-w-0">
                        <div className="flex items-center gap-2">
                          <span className="font-display font-semibold text-white">{p.title}</span>
                        </div>
                        {p.summary && <p className="mt-1 text-xs leading-relaxed text-meta">{p.summary}</p>}
                      </div>
                      <div className="flex shrink-0 items-center gap-3 pt-0.5">
                        <StatusBadge policy={p} />
                        <Icon name="chevron-right" size={16} className="text-[#52525b]" />
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className="mt-12 rounded-2xl border border-surface-border bg-surface-3 p-5 text-xs leading-relaxed text-meta">
          NO PURCHASE NECESSARY. A PURCHASE WILL NOT INCREASE YOUR CHANCES OF WINNING. MUST BE 18+ (or the age of majority in your
          jurisdiction, whichever is greater). VOID WHERE PROHIBITED. Operated by {ENTITY}, {ADDRESS}.
        </div>
      </main>
    </div>
  );
}
